<template>
    <div class="user-dropdown-content" @mouseleave="$emit('hideDropdown')" v-show="showDropdown">
        <!--
        <router-link to="/plano" v-if="user.pla_vis">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="21" viewBox="0 0 25 21" fill="none">
                <path d="M16.5626 19.5297V17.5297C16.5626 16.4688 16.1412 15.4514 15.391 14.7012C14.6409 13.9511 13.6235 13.5297 12.5626 13.5297H5.56262C4.50176 13.5297 3.48434 13.9511 2.73419 14.7012C1.98405 15.4514 1.56262 16.4688 1.56262 17.5297V19.5297M17.5626 9.52966L19.5626 11.5297L23.5626 7.52966M13.0626 5.52966C13.0626 7.7388 11.2718 9.52966 9.06262 9.52966C6.85348 9.52966 5.06262 7.7388 5.06262 5.52966C5.06262 3.32052 6.85348 1.52966 9.06262 1.52966C11.2718 1.52966 13.0626 3.32052 13.0626 5.52966Z" stroke="#009488" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span style="color: #009488;">
                Meu Plano
            </span>
        </router-link>
        -->
        <a href @click.prevent="logout">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path d="M7.71484 19.0042H3.71484C3.18441 19.0042 2.6757 18.7934 2.30063 18.4184C1.92556 18.0433 1.71484 17.5346 1.71484 17.0042V3.00415C1.71484 2.47372 1.92556 1.96501 2.30063 1.58994C2.6757 1.21486 3.18441 1.00415 3.71484 1.00415H7.71484M14.7148 15.0042L19.7148 10.0042M19.7148 10.0042L14.7148 5.00415M19.7148 10.0042H7.71484" stroke="#FF0C37" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg> 
            <span style="color: #FF0C37;">
                Logout
            </span>
        </a>
    </div>
</template>

<script>
import { userCredential } from '@/global'
import { mapState } from 'vuex'

export default {
    name: 'UserDropdown',
    computed: mapState(['user']),
    props: ["showDropdown"],
    methods: {
        logout() {
            localStorage.removeItem(userCredential)
            this.$store.commit('setUser', null)
            this.$router.push({ name: 'auth' })
        }
    }
}
</script>

<style>
    .user-dropdown-content {
        position: absolute;
        left: 280px;
        bottom: 20px;
        background-color: white;
        border-radius: 10px;
        min-width: 220px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        padding: 10px;
        z-index: 1;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }

    .user-dropdown-content a {
        text-decoration: none;
        color: #333;
        padding: 15px;
        filter: invert(0.5);
        transition: .3s;
    }

    .user-dropdown-content a:hover {
        text-decoration: none;
        filter: invert(0);
    }

    .user-dropdown-content a svg {
        margin-right: 15px;
    }

    .user-dropdown hr {
        border: 0;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
    @media (max-width: 768px) {
        .user-dropdown-content {
            left: 130px;
            bottom: 8px;
        }
    }
</style>